import React from "react";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import { HomePage } from "../HomePage/HomePage";
import { CountryList } from "../Country/List/CountryList";
import { TemplatesAwaitingApproval } from "../TemplatesAwaitingApproval/TemplatesAwaitingApproval";
import { BatchMessageConfiguration } from "../BatchMessageConfiguration/BatchMessageConfiguration";
import HandleUserLogin from "../HandleUserLogin";
import { Security, SecureRoute, LoginCallback } from "@okta/okta-react";
import Shared from "../../common/shared";
import { TemplateList } from "../TemplateList/TemplateList";
import { AccessDeniedPage } from "../AccessDeniedPage/AccessDeniedPage";
import { RequestForHelpConfiguration } from "../RequestForHelpTemplates/RequestForHelpConfiguration/RequestForHelpConfiguration";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { VariablesList } from "../Variables/List/VariablesList";
import { ScheduledTemplateList } from "../ScheduledTemplateList/ScheduledTemplateList";
import { TemplateLibraryViewPage } from "../TemplateLibraryViewPage/TemplateLibraryViewPage";

const NotFound = () => {
	// TODO: add new component with proper styling
	return <h2>Page Not Found</h2>;
};

export const RouterViewOkta: React.FC = () => {
	const CLIENT_ID = `${process.env.REACT_APP_CLIENT_ID}`;
	const ISSUER = `${process.env.REACT_APP_ISSUER}`;
	const history = useHistory();

	const oktaAuth = new OktaAuth({
		issuer: ISSUER,
		clientId: CLIENT_ID,
		redirectUri: `${window.location.origin}/login/callback`,
		scopes: Shared.oktaScopes(),
		pkce: true,
		tokenManager: {
			autoRenew: true,
		},
	});

	const restoreOriginalUri = async (_oktaAuth: any, originalUri: string) => {
		history.replace(toRelativeUrl(originalUri, window.location.origin));
	};

	return (
		<div>
			{/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
			<Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
				{/* component to handle access token and logged in user info */}
				<HandleUserLogin />
				<Switch>
					<Route exact path="/login/callback" component={LoginCallback} />
					<SecureRoute exact path="/home" component={HomePage} />
					<Route exact path="/">
						<Redirect to="/home" />
					</Route>
					<SecureRoute
						exact
						path="/projectList"
						component={
							Shared.isUserGlobalAdminOrCountryAdmin()
								? CountryList
								: AccessDeniedPage
						}
					/>
					<SecureRoute
						exact
						path="/variablesList"
						component={
							Shared.isUserGlobalAdminOrCountryAdmin()
								? VariablesList
								: AccessDeniedPage
						}
					/>
					<SecureRoute
						exact
						path="/scheduledTemplates"
						component={
							Shared.isUserGlobalAdminOrCountryAdmin()
								? ScheduledTemplateList
								: AccessDeniedPage
						}
					/>
					<SecureRoute
						exact
						path="/templateLibraryView"
						component={TemplateLibraryViewPage}
					></SecureRoute>
					<SecureRoute
						exact
						path="/templatesAwaitingApproval"
						component={
							Shared.canApproveOrRejectTemplate()
								? TemplatesAwaitingApproval
								: AccessDeniedPage
						}
					></SecureRoute>
					<SecureRoute
						exact
						path="/batchMessageConfiguration/:partitionKey?/:rowKey?"
						component={BatchMessageConfiguration}
					></SecureRoute>
					<SecureRoute
						exact
						path="/templateList"
						component={TemplateList}
					></SecureRoute>
					<SecureRoute
						exact
						path="/requestForHelpConfiguration/:partitionKey?/:rowKey?"
						component={RequestForHelpConfiguration}
					></SecureRoute>
					<SecureRoute
						exact
						path="/accessDenied"
						component={AccessDeniedPage}
					></SecureRoute>
					<SecureRoute exact path="*">
						<NotFound />
					</SecureRoute>
				</Switch>
			</Security>
		</div>
	);
};
